// extracted by mini-css-extract-plugin
export default {"section":"WhiteTextSection_section__veyVO","container":"WhiteTextSection_container__XaKU1","text":"WhiteTextSection_text__wgrFn"};